angular.module('app').controller('viewReportController', function ($window, $scope, $routeParams, $location, safeApply, systemService) {

  const params = $routeParams
  let css = ''
  initController()

  function initController() {
    $scope.file_info = {
      user_id: params.user_id,
      user_token: params.user_token,
      prop_id: params.prop_id,
      use_selected_items_only: false,
      create_pdf: false
    }
    getReport()
  }

  async function getReport() {
    let HTML = await systemService.functionCall({ type: 'generateHTML', params: $scope.file_info })
    console.log('HTML :>> ', HTML);
    $scope.htmlOutput = HTML.data.data.html
    safeApply($scope)
  }

  $scope.printDocument = () => {
    $window.print()
  }
  $scope.refresh = () => {
    $scope.htmlOutput = "Refreshing..."
    getReport()
  }
  $scope.returnToDashboard = () => {
    $window.close();
    // return_path = `/${params.user_id}/${params.user_token}/${params.prop_id}/${params.rpt || ''}`
    // $location.path(return_path)
  }

})